(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_blog-post-content"] && !Shopify.designMode) return;
  try {
    // Always run the observer, never gated behind CSS.supports('animation-timeline: view()') —
  // mobile Safari reports that feature as supported (parses the property) while the actual
  // scroll-timeline silently never fires, so feature-detection alone left iOS with static,
  // pre-highlighted marks. The observer's inline style wins over the CSS animation either way
  // (inline specificity), so running it unconditionally is safe on browsers where the native
  // path does work too.
  document.querySelectorAll('.blog-post-content mark').forEach((mark) => {
    const observer = new IntersectionObserver(
      ([entry]) => mark.style.setProperty('--highlighted', entry.isIntersecting ? 1 : 0),
      { threshold: 1.0 }
    );
    observer.observe(mark);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_header-logo"] && !Shopify.designMode) return;
  try {
    /**
   * PERFUMALINK — logo scroll scale-pulse. 1.00 -> 1.12 grow over a
   * FIXED scroll distance (not a percentage of total page height) so the effect
   * resolves the same way on a short page and a long one, rather than stretching
   * across an entire long product/collection page. `{% javascript %}` is
   * deduplicated by Shopify per page regardless of how many times this block
   * instance renders, so this runs once even if the block is placed more than
   * once in a header layout.
   */
  (() => {
    const SETTLE_PX = 250;
    const SCALE_RANGE = 0.12;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    let ticking = false;

    function update() {
      ticking = false;
      const progress = Math.min(Math.max(window.scrollY / SETTLE_PX, 0), 1);
      const scale = (1 + progress * SCALE_RANGE).toFixed(4);
      document.querySelectorAll('.header-logo__image').forEach((img) => {
        img.style.setProperty('--pl-logo-scale', scale);
      });
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  })();
  } catch(e) { console.error(e); }
})();

})();
